/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import farmerDeviceDetailsTemplate from "./farmer-device-details.tpl.html";
import cropBackground from './../../img/crop.jpg';// eslint-disable-line

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.farmerDeviceDetails', [])
    .directive('farmerDeviceDetails', FarmerDeviceDetails)
    .name;

/*@ngInject*/
function FarmerDeviceDetails() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: FarmerDeviceDetailsController,
        controllerAs: 'vm',
        templateUrl: farmerDeviceDetailsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function FarmerDeviceDetailsController($scope, agTypes, agUtils, userService, deviceService) {// eslint-disable-line

    let vm = this;

    vm.agTypes = agTypes;
    vm.agUtils = agUtils;
    vm.deviceId = null;
    vm.device = null;
    vm.loading = false;
    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';

    $scope.$watch('vm.ctx', () => {
        if (vm.ctx && vm.showData) {
            // vm.ctx.widgetConfig.widgetStyle["background"] = "url(" + cropBackground + ") center no-repeat";// eslint-disable-line
            // vm.ctx.widgetConfig.widgetStyle["background-size"] = "cover";// eslint-disable-line
            if (vm.ctx.stateController) {
                vm.deviceId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadDevice();
            $scope.$watch(() => {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newDeviceId, prevDeviceId) {
                    if (newDeviceId && !angular.equals(newDeviceId, prevDeviceId)) {
                        vm.deviceId = newDeviceId;
                        loadDevice();
                    }
                }
            );
        }
    });

    function loadDevice() {
        if (vm.deviceId) {
            vm.loading = true;
            deviceService.getDevice(vm.deviceId.id).then(
                (device) => {
                    vm.device = device;
                    vm.loading = false;
                },
                () => {
                    vm.loading = false;
                }
            );
        }
    }
}
